export default {
    LOAD_MORE_AMOUNT: 20,
};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-constants.js